import { createSlice } from "@reduxjs/toolkit";
import { fetchCampaignCreateDetails, fetchCampaignDetails, fetchCampaignScreeningQuestionsThunk } from "./thunk";
import { CampaignDetailsSlice } from "types/campaign/details";

const initialState: CampaignDetailsSlice = {
    loading: false,
    error: null,
    campaigns: {},
    screeningQuestions: {}
};


const campaignRequirements = createSlice({
    name: 'campaignDetails',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchCampaignDetails.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchCampaignDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            const {campaign, properties, gig_types, goal_list} = action.payload;
            state.campaigns[campaign.uuid] = {campaign, properties, gig_types, goal_list, last_fetched_at: Date.now()}
        })
        .addCase(fetchCampaignDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Failed to fetch campaign details"
        })
        .addCase(fetchCampaignCreateDetails.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchCampaignCreateDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            const {properties, gig_types, goal_list} = action.payload;
            state.campaigns['create'] = {campaign: null as any, properties, gig_types, goal_list, last_fetched_at: Date.now()}
        })
        .addCase(fetchCampaignCreateDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Failed to fetch campaign create details"
        })
        .addCase(fetchCampaignScreeningQuestionsThunk.fulfilled, (state, action) => {
            const {questions, campaignId} = action.payload;
            state.screeningQuestions[campaignId] = {questions, last_fetched_at: Date.now()};
        })
    }
});

export default campaignRequirements.reducer;